'use client';

import { IoPauseCircleOutline } from 'react-icons/io5';

import { Button } from '../../../../button';
import {
  ActionDialogButtons,
  ActionDialogContent,
  Dialog,
  DialogContent,
} from '../../../../dialog';

type PauseDialogProps = {
  open: boolean;
  /** A pause or resume is still waiting on the server. */
  isSyncing: boolean;
  onResume: () => void;
  onClose?: () => void;
  testId?: string;
};

function PauseDialog({
  open,
  isSyncing,
  onResume,
  onClose,
  testId,
}: PauseDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent data-testid={testId}>
        <ActionDialogContent
          icon={<IoPauseCircleOutline />}
          title="Simulacro en pausa"
          subtitle="El tiempo está detenido. Continúa cuando estés listx."
        >
          <ActionDialogButtons>
            {onClose && (
              <Button
                variant="outline-primary"
                disabled={isSyncing}
                onClick={onClose}
              >
                Salir
              </Button>
            )}
            <Button
              variant="primary"
              loading={isSyncing}
              disabled={isSyncing}
              onClick={onResume}
            >
              Continuar
            </Button>
          </ActionDialogButtons>
        </ActionDialogContent>
      </DialogContent>
    </Dialog>
  );
}

export { PauseDialog };
